/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSendPostRequestDestination
 */
export interface MessageSendPostRequestDestination {
    /**
     * 
     * @type {string}
     * @memberof MessageSendPostRequestDestination
     */
    mmsi?: string;
}

/**
 * Check if a given object implements the MessageSendPostRequestDestination interface.
 */
export function instanceOfMessageSendPostRequestDestination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MessageSendPostRequestDestinationFromJSON(json: any): MessageSendPostRequestDestination {
    return MessageSendPostRequestDestinationFromJSONTyped(json, false);
}

export function MessageSendPostRequestDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSendPostRequestDestination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
    };
}

export function MessageSendPostRequestDestinationToJSON(value?: MessageSendPostRequestDestination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
    };
}

